const getDefaultState = () => {
    return {
        languages: [],
        translationLanguages: [],
        tags: [],
        translationJob: null,
    }
}

const state = getDefaultState()

const getters = {
    languages(state: any) {
        return state.languages
    },

    language: (state: any) => (id: string) => {
        return state.languages.find((language) => language._id == id)
    },

    translationLanguages(state: any) {
        return state.translationLanguages
    },

    translationLanguage: (state: any) => (id: string) => {
        return state.translationLanguages.find((language) => language._id == id)
    },

    tags(state: any) {
        return state.tags
    },

    translationJob(state: any) {
        return state.translationJob
    },
}

const mutations = {
    languages(state: any, payload: any) {
        state.languages = payload
    },

    language(state: any, payload: any) {
        let index = state.languages.findIndex((lang) => lang._id == payload._id)
        Object.assign(state.languages[index], payload)
    },

    translationLanguages(state: any, payload: any) {
        state.translationLanguages = payload
    },

    translationLanguage(state: any, payload: any) {
        let index = state.translationLanguages.findIndex((lang) => lang._id == payload._id)
        Object.assign(state.translationLanguages[index], payload)
    },

    tags(state: any, payload: any) {
        state.tags = payload
    },

    tag(state: any, payload: any) {
        let index = state.tags.findIndex((lang) => lang._id == payload._id)
        if (index > -1) {
            Object.assign(state.tags[index], payload)
        } else {
            state.tags.push(payload)
        }
    },

    translationJob(state: any, payload: any) {
        state.translationJob = payload
    },

    //RESET
    resetLanguage(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
